import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PatientPortal = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const upcomingAppointments = [
    {
      id: 1,
      date: '2024-03-20',
      time: '10:00 AM',
      type: 'Dental Cleaning',
      doctor: 'Dr. Sarah Johnson',
      status: 'Confirmed'
    },
    {
      id: 2,
      date: '2024-04-05',
      time: '2:30 PM',
      type: 'Root Canal',
      doctor: 'Dr. Michael Chen',
      status: 'Pending'
    }
  ];

  const recentDocuments = [
    {
      id: 1,
      name: 'Dental X-Ray Results',
      date: '2024-02-15',
      type: 'X-Ray'
    },
    {
      id: 2,
      name: 'Treatment Plan',
      date: '2024-02-10',
      type: 'Document'
    },
    {
      id: 3,
      name: 'Insurance Claim Form',
      date: '2024-02-01',
      type: 'Form'
    }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'overview':
        return (
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Next Appointment</h3>
                <p className="text-2xl font-bold text-orange-500">March 20, 2024</p>
                <p className="text-gray-600">10:00 AM - Dental Cleaning</p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Outstanding Balance</h3>
                <p className="text-2xl font-bold text-[#1E2A4A]">$0.00</p>
                <p className="text-green-600">All payments up to date</p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-lg">
                <h3 className="text-lg font-semibold text-[#1E2A4A] mb-2">Insurance Status</h3>
                <p className="text-2xl font-bold text-[#1E2A4A]">Active</p>
                <p className="text-gray-600">Coverage until Dec 2024</p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-[#1E2A4A] mb-4">Upcoming Appointments</h3>
              <div className="space-y-4">
                {upcomingAppointments.map(appointment => (
                  <div key={appointment.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                    <div>
                      <p className="font-semibold text-[#1E2A4A]">{appointment.type}</p>
                      <p className="text-gray-600">{appointment.date} at {appointment.time}</p>
                      <p className="text-sm text-gray-500">with {appointment.doctor}</p>
                    </div>
                    <span className={`px-3 py-1 rounded-full text-sm ${
                      appointment.status === 'Confirmed' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                    }`}>
                      {appointment.status}
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-[#1E2A4A] mb-4">Recent Documents</h3>
              <div className="space-y-4">
                {recentDocuments.map(doc => (
                  <div key={doc.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
                    <div className="flex items-center space-x-4">
                      <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center">
                        {doc.type === 'X-Ray' ? '📷' : doc.type === 'Document' ? '📄' : '📋'}
                      </div>
                      <div>
                        <p className="font-semibold text-[#1E2A4A]">{doc.name}</p>
                        <p className="text-sm text-gray-500">Added on {doc.date}</p>
                      </div>
                    </div>
                    <button className="text-orange-500 hover:text-orange-600">
                      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                      </svg>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        );
      case 'appointments':
        return (
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold text-[#1E2A4A] mb-4">Schedule New Appointment</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Date</label>
                <input type="date" className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Preferred Time</label>
                <input type="time" className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-2">Reason for Visit</label>
                <textarea className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500" rows="3"></textarea>
              </div>
            </div>
            <button className="mt-4 bg-orange-500 text-white px-6 py-3 rounded-xl hover:bg-orange-600 transition-colors">
              Request Appointment
            </button>
          </div>
        );
      case 'medical-history':
        return (
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold text-[#1E2A4A] mb-4">Medical History</h3>
            <div className="space-y-6">
              <div>
                <h4 className="font-semibold text-[#1E2A4A] mb-2">Allergies</h4>
                <p className="text-gray-600">None reported</p>
              </div>
              <div>
                <h4 className="font-semibold text-[#1E2A4A] mb-2">Current Medications</h4>
                <p className="text-gray-600">None reported</p>
              </div>
              <div>
                <h4 className="font-semibold text-[#1E2A4A] mb-2">Previous Dental Work</h4>
                <ul className="list-disc list-inside text-gray-600">
                  <li>Dental cleaning (2023)</li>
                  <li>Filling (2022)</li>
                </ul>
              </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-24">
      <div className="container mx-auto px-6 py-8">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8">
            <div>
              <h1 className="text-3xl font-bold text-[#1E2A4A]">Patient Portal</h1>
              <p className="text-gray-600 mt-2">Welcome back, John Doe</p>
            </div>
            <div className="mt-4 md:mt-0">
              <button className="bg-orange-500 text-white px-6 py-3 rounded-xl hover:bg-orange-600 transition-colors">
                Update Profile
              </button>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="border-b border-gray-200">
              <nav className="flex space-x-8 px-6">
                {['overview', 'appointments', 'medical-history'].map((tab) => (
                  <button
                    key={tab}
                    onClick={() => setActiveTab(tab)}
                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === tab
                        ? 'border-orange-500 text-orange-500'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1).replace('-', ' ')}
                  </button>
                ))}
              </nav>
            </div>

            <div className="p-6">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientPortal; 